import React from "react";
import {useStateContext} from "../../helpers/state-context.js";

const iconStyle = {
    position: 'relative',
    width: 25,
    height: 25,
    margin: 5,
    fontSize: 22,
    cursor: 'pointer',
    padding: 10,
    borderRadius: '50%',
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const CircleIcon = function (props) {
    const [state] = useStateContext(['renderSize'])
    const viewSize = ['xs', 'sm'].includes(state.renderSize) ? 'small' : 'full';
    return <span id={props.id}
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            style={{
                ...iconStyle,
                width: (viewSize=== 'small') ?  15 : 25,
                height:(viewSize=== 'small') ?  15 : 25,
                ...props.style
            }}>
        {props.bell ? props.bell : null}
        {(props.text) ?
            <span style={{
                fontSize: 18,
                fontWeight: 'bold',
                ...props.textStyle
            }}>
                {props.text}
            </span> :
            <img src={props.src} alt={props.alt} style={props.imageStyle}/>
        }
    </span>
}

export {CircleIcon}